module.exports = __webpack_public_path__ + "img/icon-whatsapp.43d5f42.svg";